import { takeEvery, put } from 'redux-saga/effects';
import { exportAllocationLogs, appNotify, setChannelWorkflowLoadingOverlayState } from 'store/actions';
import { postWithTokenV2 } from 'api/network';

export function* exportAllocationLogsSaga() {
  yield takeEvery(exportAllocationLogs, function* ({ payload }) {
    console.log('exportAllocationSaga', payload);
    const { txnOppIds } = payload;
    try {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Copying allocation logs to clipboard...' }));
      const logEvents = yield postWithTokenV2(`/api/admin/Utilities/exportAllocationLogsByIds`, txnOppIds);
      let logEventString = logEvents.join('\r\n\r\n');
      let formattedLogEventString = logEventString.replace(/\\r\\n/gm, '\r\n');
      navigator.clipboard.writeText(formattedLogEventString);
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify('Allocation logs copied to clipboard', 'success', { autoHideDuration: 1500 }));
    } catch (error) {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify(error.message, 'error'));
    }
  });
}

